import { useEffect } from "react";

const SITE_URL = "https://scorpionpdf.com.br";

function upsert(selector, create, attr, value) {
    let el = document.querySelector(selector);
    if (!el) {
        el = document.createElement(create.tag);
        for (const [k, v] of Object.entries(create.attrs)) el.setAttribute(k, v);
        document.head.appendChild(el);
    }
    el.setAttribute(attr, value);
}

/** SEO por rota: title, description, canonical e robots (dominio oficial). */
export function Seo({ title, description, noindex = false }) {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            upsert('meta[name="description"]', { tag: "meta", attrs: { name: "description" } }, "content", description);
        }
        upsert('link[rel="canonical"]', { tag: "link", attrs: { rel: "canonical" } }, "href", SITE_URL + window.location.pathname);
        upsert('meta[property="og:url"]', { tag: "meta", attrs: { property: "og:url" } }, "content", SITE_URL + window.location.pathname);
        upsert(
            'meta[name="robots"]',
            { tag: "meta", attrs: { name: "robots" } },
            "content",
            noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"
        );
    }, [title, description, noindex]);
    return null;
}
